import React, { useState, useRef, useEffect } from "react";
import { setLanguage, getLanguage } from "../../utils/SecurityService";
import { Images } from "../Common/Images";
import { useTranslation } from "react-i18next";
import i18n from  "../../modules/i18n/i18n";
const LanguageSelector = ({ deferApply = false, onSelect } = {}) => {
  const { t } =  useTranslation("common");
  const [isOpen, setIsOpen] = useState(false);
  const [pendingCode, setPendingCode] = useState(null);
  const rootRef = useRef(null);
 
  // ✅ language list MUST be inside component
/* const languages = [
    { code: "cs", label: t("language_czech") },
    { code: "de", label: t("language_german") },
    { code: "en", label: t("language_english") },
    { code: "fr", label: t("language_french") },
 
    { code: "it", label: t("language_italian") },
    { code: "nl", label: t("language_dutch") },
    { code: "pl", label: t("language_polish") }
  ]; */
 
//const languages = useMemo(() => [
  const languages =  [
  {
   
    code: "cs",
    label: t("language_czech"),
    flagName: "Čeština",
    imageName: "czech-republic",
    src: Images.CzechRepublic
  },
  {
    code: "nl",                    //"language_dutch": "Nederlands",
    label: t("language_dutch"),  
    flagName: "Nederlands",
    imageName: "netherlands",
    src: Images.Netherlands
  },
  {
    code: "de",                    
  label: t("language_german"),  //"language_german": "Deutsch",
    flagName: "Deutsch",
    imageName: "germany",
    src: Images.Germany
  },
  {
    code: "en",
    label: t("language_english"),
    flagName: "English",
    imageName: "united-kingdom",
    src: Images.UnitedKingdom
  },
  {
    code: "es",
    label: t("language_spanish"),
    flagName: "Español",
    imageName: "spain",
    src: Images.Spain
  },
  {
    code: "fr",
    label: t("language_french"),
    flagName: "Français",
    imageName: "france",
    src: Images.France
  },
  {
    code: "it",
    label: t("language_italian"),
    flagName: "Italiano",
    imageName: "italy",
    src: Images.Italy
  },
  {
    code: "pl",
    label: t("language_polish"),
    flagName: "Polski",
    imageName: "poland",
    src: Images.Poland
  },
  {
    code: "pt",
    label: t("language_portuguese"),
    flagName: "Português",
    imageName: "portugal",
    src: Images.Portugal
  },
  {
    code: "ga",
    label: t("language_irish"),
    flagName: "Gaeilge",
    imageName: "ireland",
    src: Images.Ireland
  }
]
//], [i18n.language]);

  // Render the list alphabetically by the displayed (native) label.
  // Sort a copy so the original `languages` order (and the languages[0] fallback) stays intact.
  const sortedLanguages = [...languages].sort((a, b) =>
    a.label.localeCompare(b.label)
  );
 
  useEffect(() => {
    document.body.dir = i18n.dir();
  });
 
useEffect(() => {
  const savedLang = getLanguage();
 
  if (savedLang) {
    try {
      const parsed = JSON.parse(savedLang);
 
      if (parsed.code && parsed.code !== i18n.language) {
        i18n.changeLanguage(parsed.code);
      }
 
    } catch {
      console.error("Invalid language session");
    }
  }
 
  document.body.dir = i18n.dir();
}, []);
 
 
  const toggleDropdown = () => {
    setIsOpen(prev => !prev);
  };
 
const changeLanguage = (lng) => {
  const selected = languages.find(l => l.code === lng);
  if (!selected) return;
 
  const languageObj = {
    code: selected.code,
    flagName: selected.flagName,
    imageName: selected.imageName,
    src: selected.src
  };

  // Deferred mode: stage the choice only; the parent applies it on Save.
  if (deferApply) {
    setPendingCode(selected.code);
    onSelect?.(languageObj);
    setIsOpen(false);
    return;
  }

  i18n.changeLanguage(selected.code);

  setLanguage(JSON.stringify(languageObj));

  setIsOpen(false);

  window.location.reload();
};
 
 
 
  // close when clicking outside
  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (rootRef.current && !rootRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
 
    document.addEventListener("mousedown", handleOutsideClick);
    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, []);
 
  //const selectedLanguage =    languages.find(l => l.code === i18n.language) || languages[0];
  // In deferred mode show the staged (pending) selection until it is applied on Save.
  const activeCode = pendingCode ?? i18n.language;
  const selectedLanguage =
    languages.find(l => l.code === activeCode) || languages[0];
 
  return (
    <div className="select-wrapper position-relative">
      <div
        ref={rootRef}
        className="custom-dropdown green-icon-drop-down header-dropdown"
        style={{ position: "relative" }}
      >
        {/* Dropdown button */}
        <div
          role="button"
          onClick={toggleDropdown}
          className="dropdown-toggle form-control custom-dropdown-btn ctm-select"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            cursor: "pointer",
          }}
        >
          <span>{selectedLanguage.label}</span>
          {/* <span>{isOpen ? "▲" : "▼"}</span> */}
        </div>
 
        {/* Dropdown list */}
        {isOpen && (
          <div
            className="dropdown-menu-list"
            style={{
              position: "absolute",
              top: "calc(100% + 6px)",
              left: "auto",
              right: "auto",
              zIndex: 1,
              background: "#fff",
              border: "1px solid var(--color-theme-green)",
              borderRadius: "4px",
              // boxShadow: "0 10px 30px rgba(0,0,0,.15)",
              maxHeight: "240px",
              overflowY: "auto",
              width: "100%",
            }}
          >
            {sortedLanguages.map((lng) => (
              <div
                key={lng.code}
                onClick={() => changeLanguage(lng.code)}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  padding: "8px 12px",
                  cursor: "pointer",
                  whiteSpace: "nowrap",
                  fontFamily: "var(--font-roboto)",
                  fontSize: "12px",
                  lineHeight: "24px",
                  fontWeight: "400",
                }}
              >
                <input
                  type="radio"
                  checked={selectedLanguage.code === lng.code}
                  readOnly
                  style={{
                    marginRight: "8px",
                    height: "auto", accentColor: "#1c988a" }}
                />
                <span>{lng.label}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
 
export default LanguageSelector;
 
 
 
// import React from 'react';
// import { useTranslation } from 'react-i18next';
 
// const LanguageDropdown = () => {
//   const { i18n } = useTranslation();
 
//   const handleLanguageChange = (event) => {
//     i18n.changeLanguage(event.target.value);
//   };
 
//   return (
//     <div className="select-wrapper position-relative">
//     <select className="form-control" id="lang-options"
//       onChange={handleLanguageChange} value={i18n.language}
//     >
//       {languages.map((lng) => (
//         <option key={lng.code} value={lng.code}>
//           {lng.lang}
//         </option>
//       ))}
//     </select>
//   </div>
 
    // <select onChange={handleLanguageChange} value={i18n.language}>
    //   <option value="en">English</option>
    //   <option value="fr">Français</option>
    //   {/* Add options for other languages */}
    // </select>
// //   );
// // };
 
// export default LanguageDropdown;
